/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AccountDeletionRouteImport } from './routes/account-deletion'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAccountsRouteImport } from './routes/_app.accounts'
import { Route as AppIncomingRouteImport } from './routes/_app.incoming'
import { Route as AppInventoryRouteImport } from './routes/_app.inventory'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth.sign-in'
import { Route as AuthSignUpRouteImport } from './routes/_auth.sign-up'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth.two-factor'
import { Route as InviteIdRouteImport } from './routes/invite.$id'
import { Route as AppDropsIndexRouteImport } from './routes/_app.drops.index'
import { Route as AppDropsIdRouteImport } from './routes/_app.drops.$id'
import { Route as AppOrdersIndexRouteImport } from './routes/_app.orders.index'
import { Route as AppOrdersOrderNumberRouteImport } from './routes/_app.orders.$orderNumber'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletionRoute = AccountDeletionRouteImport.update({
  id: '/account-deletion',
  path: '/account-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppIncomingRoute = AppIncomingRouteImport.update({
  id: '/incoming',
  path: '/incoming',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const InviteIdRoute = InviteIdRouteImport.update({
  id: '/invite/$id',
  path: '/invite/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDropsIndexRoute = AppDropsIndexRouteImport.update({
  id: '/drops/',
  path: '/drops/',
  getParentRoute: () => AppRoute,
} as any)
const AppDropsIdRoute = AppDropsIdRouteImport.update({
  id: '/drops/$id',
  path: '/drops/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderNumberRoute = AppOrdersOrderNumberRouteImport.update({
  id: '/orders/$orderNumber',
  path: '/orders/$orderNumber',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/device': typeof DeviceRoute
  '/onboarding': typeof OnboardingRoute
  '/accounts': typeof AppAccountsRoute
  '/incoming': typeof AppIncomingRoute
  '/inventory': typeof AppInventoryRoute
  '/settings': typeof AppSettingsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/invite/$id': typeof InviteIdRoute
  '/drops/$id': typeof AppDropsIdRoute
  '/orders/$orderNumber': typeof AppOrdersOrderNumberRoute
  '/drops/': typeof AppDropsIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/device': typeof DeviceRoute
  '/onboarding': typeof OnboardingRoute
  '/accounts': typeof AppAccountsRoute
  '/incoming': typeof AppIncomingRoute
  '/inventory': typeof AppInventoryRoute
  '/settings': typeof AppSettingsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/invite/$id': typeof InviteIdRoute
  '/drops/$id': typeof AppDropsIdRoute
  '/orders/$orderNumber': typeof AppOrdersOrderNumberRoute
  '/drops': typeof AppDropsIndexRoute
  '/orders': typeof AppOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/account-deletion': typeof AccountDeletionRoute
  '/device': typeof DeviceRoute
  '/onboarding': typeof OnboardingRoute
  '/_app/accounts': typeof AppAccountsRoute
  '/_app/incoming': typeof AppIncomingRoute
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/invite/$id': typeof InviteIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/drops/$id': typeof AppDropsIdRoute
  '/_app/orders/$orderNumber': typeof AppOrdersOrderNumberRoute
  '/_app/drops/': typeof AppDropsIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-deletion'
    | '/device'
    | '/onboarding'
    | '/accounts'
    | '/incoming'
    | '/inventory'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor'
    | '/invite/$id'
    | '/drops/$id'
    | '/orders/$orderNumber'
    | '/drops/'
    | '/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-deletion'
    | '/device'
    | '/onboarding'
    | '/accounts'
    | '/incoming'
    | '/inventory'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor'
    | '/invite/$id'
    | '/drops/$id'
    | '/orders/$orderNumber'
    | '/drops'
    | '/orders'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/account-deletion'
    | '/device'
    | '/onboarding'
    | '/_app/accounts'
    | '/_app/incoming'
    | '/_app/inventory'
    | '/_app/settings'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/two-factor'
    | '/invite/$id'
    | '/_app/'
    | '/_app/drops/$id'
    | '/_app/orders/$orderNumber'
    | '/_app/drops/'
    | '/_app/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AccountDeletionRoute: typeof AccountDeletionRoute
  DeviceRoute: typeof DeviceRoute
  OnboardingRoute: typeof OnboardingRoute
  InviteIdRoute: typeof InviteIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deletion': {
      id: '/account-deletion'
      path: '/account-deletion'
      fullPath: '/account-deletion'
      preLoaderRoute: typeof AccountDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/incoming': {
      id: '/_app/incoming'
      path: '/incoming'
      fullPath: '/incoming'
      preLoaderRoute: typeof AppIncomingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/invite/$id': {
      id: '/invite/$id'
      path: '/invite/$id'
      fullPath: '/invite/$id'
      preLoaderRoute: typeof InviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/drops/': {
      id: '/_app/drops/'
      path: '/drops'
      fullPath: '/drops/'
      preLoaderRoute: typeof AppDropsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drops/$id': {
      id: '/_app/drops/$id'
      path: '/drops/$id'
      fullPath: '/drops/$id'
      preLoaderRoute: typeof AppDropsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$orderNumber': {
      id: '/_app/orders/$orderNumber'
      path: '/orders/$orderNumber'
      fullPath: '/orders/$orderNumber'
      preLoaderRoute: typeof AppOrdersOrderNumberRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRoute
  AppIncomingRoute: typeof AppIncomingRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDropsIdRoute: typeof AppDropsIdRoute
  AppOrdersOrderNumberRoute: typeof AppOrdersOrderNumberRoute
  AppDropsIndexRoute: typeof AppDropsIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,
  AppIncomingRoute: AppIncomingRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppDropsIdRoute: AppDropsIdRoute,
  AppOrdersOrderNumberRoute: AppOrdersOrderNumberRoute,
  AppDropsIndexRoute: AppDropsIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AccountDeletionRoute: AccountDeletionRoute,
  DeviceRoute: DeviceRoute,
  OnboardingRoute: OnboardingRoute,
  InviteIdRoute: InviteIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
